<template>
    <v-container
        id="painelRastrearEntrega"
        fluid
        tag="section"
        class="pt-0"
    >
        <v-row id="rastrearEntrega">
            <v-col cols="12">
            <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
            >
                <div class="card-header-dashbord">
                    <v-row>
                        <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                        >
                        <div class="mapa-header__left">
                          <v-icon
                            class="mr-2"
                            :style="{ color: corPrimaria }"
                          >
                            mdi-map-marker-path
                          </v-icon>
                          <span class="mapa-header__title">Rastreamento de Motoristas</span>
                          <span class="mapa-header__sub ml-3">Posição em tempo real</span>
                        </div>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                        >
                        <v-tooltip top>
                            <template
                            v-slot:activator="{ on, attrs }"
                            >
                            <v-icon
                                id="iconInformationFatxMetaComercial4"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('420')"
                            >
                                mdi-information-outline
                            </v-icon>
                            </template>
                            <div
                                v-if="!carregandoTooltip"
                                v-html="textoOrientacao"
                            />
                        </v-tooltip>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <mapa-entregas />
                    </v-col>
                </v-row>
                </v-card-actions>
            </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardRastrearEntregas',
    components: {
      MapaEntregas: () => import('../../components/magisEntrega/MapaEntregas'),
    },
    data: () => ({
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
      corPrimaria: localStorage.corPrimaria || '#1976D2',
    }),

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Rastrear Entregas')
        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },
    },
  }
</script>

<style scoped>

  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }
  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }
  .mapa-header__left {
    display: flex;
    align-items: center;
  }
  .mapa-header__title {
    font-size: 15px;
    font-weight: 600;
    color: #222;
  }
  .mapa-header__sub {
    font-size: 11px;
    color: #888;
  }
</style>

<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

</style>
